module.exports = __webpack_public_path__ + "static/media/circle-cross.2cfb1bbc.svg";